<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-blue">
          <div class="card-icon">
            <md-icon>rule</md-icon>
          </div>
          <h4 class="title">Labour Schedules List (Take On)</h4>
        </md-card-header>
        <md-card-content>
          <div class="md-layout">
            <div class="md-layout-item md-inline-checkboxes">
              <md-radio v-model="timeFilter" value="all" @click="getList">All</md-radio>
              <md-radio v-model="timeFilter" value="active" @click="getList">Active</md-radio>
              <md-radio v-model="timeFilter" value="current" @click="getList">Current</md-radio>
            </div>
          </div>
          <md-table
              :value="schedules"
              :md-sort.sync="sortation.field"
              :md-sort-order.sync="sortation.order"
              :md-sort-fn="customSort"
              class="paginated-table table-striped table-hover"
          >
            <md-table-toolbar>
              <md-field>
                <label>Per page</label>
                <md-select v-model="pagination.perPage" name="pages">
                  <md-option
                      v-for="item in pagination.perPageOptions"
                      :key="item"
                      :label="item"
                      :value="item">
                    {{ item }}
                  </md-option>
                </md-select>
              </md-field>

              <md-field>
                <md-input
                    v-model="query"
                    type="search"
                    class="mb-3"
                    clearable
                    style="width: 200px"
                    placeholder="Search ..."
                >
                </md-input>
              </md-field>
            </md-table-toolbar>

            <md-table-empty-state
                md-label="No item found"
                :md-description="`No data found for this query. Try a different search term.`">

            </md-table-empty-state>

            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell md-label="Takeon Number" md-sort-by="takeon_number">{{ item.takeon_number }}
              </md-table-cell>
              <md-table-cell md-label="Name" md-sort-by="labourer_name">{{ item.labourer?item.labourer.name:'' }}</md-table-cell>
              <md-table-cell md-label="Workplace">{{ item.workplace?item.workplace.name:'' }}</md-table-cell>
              <md-table-cell md-label="Activity">{{ item.activity?item.activity.name:'' }}</md-table-cell>
              <md-table-cell md-label="Shift">{{ item.shift?item.shift.name:'' }}</md-table-cell>
              <md-table-cell md-label="Start" md-sort-by="schedule_start_time">{{ item.schedule?item.schedule.start_time:'' }}
              </md-table-cell>
              <md-table-cell md-label="End" md-sort-by="schedule_end_time">{{ item.schedule?item.schedule.end_time:'' }}</md-table-cell>
              <md-table-cell md-label="Attendance Times" md-sort-by="attendance_time">
                {{ item.labourerAttendance?item.labourerAttendance.check_in_type:'' }}
              </md-table-cell>
              <md-table-cell md-label="Takeon Status" md-sort-by="status">
                <badge :type="statusBadge(item.status?item.status:'Unknown')">
                  {{ item.status ? item.status : 'Unknown' }}
                </badge>
              </md-table-cell>
              <md-table-cell md-label="Checkin Method" md-sort-by="attendance_method">
                {{ item.labourerAttendance?item.labourerAttendance.method:'' }}
              </md-table-cell>
              <md-table-cell md-label="Actions">
                <md-button
                    class="md-icon-button md-raised md-round md-info"
                    @click="goToView(item.id)"
                    style="margin: 0.2rem"
                >
                  <md-icon>visibility</md-icon>
                </md-button>
                <md-button
                    class="md-icon-button md-raised md-round md-warning"
                    @click="goToEdit(item.id)"
                    style="margin: 0.2rem"
                >
                  <md-icon>edit</md-icon>
                </md-button>
                <md-button
                    class="md-icon-button md-raised md-round md-danger"
                    @click="destroy(item)"
                    style="margin: 0.2rem"
                >
                  <md-icon>delete</md-icon>
                </md-button>
              </md-table-cell>
            </md-table-row>
          </md-table>
        </md-card-content>

        <md-card-actions md-alignment="space-between">
          <div class="">
            <p class="card-category">
              Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
            </p>
          </div>
          <pagination
              class="pagination-no-border pagination-success"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
          />
        </md-card-actions>
      </md-card>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import { Badge, Pagination } from '@/components';
import Swal from 'sweetalert2';

export default {
    components: {
        pagination: Pagination, Badge
    },

    data: () => ({
        schedules: [],
        footerTable: [
            'Name',
            'Short Name',
            'Created At',
            'Actions'
        ],

        query: null,
        timeFilter: 'all',

        sortation: {
            field: 'created_at',
            order: 'asc',
        },

        pagination: {
            perPage: 10,
            currentPage: 1,
            perPageOptions: [5, 10, 25, 50],
        },

        total: 0,
    }),

    computed: {
        sort () {
            if (this.sortation.order === 'desc') {
                return `-${this.sortation.field}`;
            }
            return this.sortation.field;
        },

        from () {
            return this.pagination.perPage * (this.pagination.currentPage - 1);
        },

        to () {
            let highBound = this.from + this.pagination.perPage;
            if (this.total < highBound) {
                highBound = this.total;
            }
            return highBound;
        },
    },

    watch: {
        query: {
            handler: 'getListDebounced',
            immediate: true,
        },
        timeFilter: {
            handler: 'getList',
            immediate: false,
            deep: true,
        },
        sortation: {
            handler: 'getList',
            immediate: false,
            deep: true,
        },
        pagination: {
            handler: 'getList',
            immediate: false,
            deep: true,
        },
    },

    methods: {
        getListDebounced: _.debounce(function () {
            this.getList();
        }, 300),

        async getList () {
            let params = {
                include: 'labourer,labourerAttendance,workplace,activity,schedule,shift',
                ...(this.sort ? { sort: this.sort } : {}),
                filter: {
                    ...(this.query ? { queryKey: this.query } : {}),
                    ...(this.timeFilter && this.timeFilter !== 'all' ? { timeFilter: this.timeFilter } : {}),
                },
                page: {
                    number: this.pagination.currentPage,
                    size: this.pagination.perPage,
                },
            };

            try {
                await this.$store.dispatch('labourerSchedules/list', params);
                this.schedules = this.$store.getters['labourerSchedules/list'];

                // this.takeonStatus()
                this.total = this.$store.getters['labourerSchedules/listTotal'];
            } catch (e) {
                this.notifyException(e);
            }
        },

        async destroy (schedule) {
            const confirmation = await Swal.fire({
                title: 'Delete Schedule Record?',
                text: `Delete schedule record for ${schedule.labourer_name} check in at ${schedule.checkin}`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, Cancel it!',
                cancelButtonText: 'No, keep it',
                confirmButtonClass: 'md-button md-success',
                cancelButtonClass: 'md-button md-danger',
                backdrop: false
            });

            if (confirmation.value === true) {
                try {
                    await this.$store.dispatch('labourerSchedules/destroy', schedule.id);
                    await this.$store.dispatch(
                        'alerts/success',
                        'Schedule deleted successfully.'
                    );
                    await this.getList();
                } catch (e) {
                    await this.$store.dispatch(
                        'alerts/alert',
                        e.response
                    );
                }
            }
        },

        takeonStatus () {
            // return "Mzuri"
            this.schedules = this.schedules.map(schedule => {
                const hoursDifferent = this.diff_hours(schedule.checkin);
                if (schedule.labourerSchedule.id.length > 0) {
                    console.log(schedule.labourerSchedule);
                    schedule.takeon_status = 'Assigned';
                    schedule.takeon_number = schedule.labourerSchedule.takeon_number;
                } else {
                    if (hoursDifferent > 5) {
                        schedule.takeon_status = 'Unsigned';
                    } else {
                        schedule.takeon_status = 'Pending';
                    }
                }
                return schedule;
            });
        },

        diff_hours (checkinTime) {
            let dt1 = new Date(checkinTime);
            let dt2 = new Date();
            let diff = (dt2.getTime() - dt1.getTime()) / 1000;
            diff /= (60 * 60);
            console.log(dt1);
            console.log(dt2);
            return Math.abs(Math.round(diff));
        },
        statusBadge (status) {
            if (status === 'Assigned') {
                return 'success';
            } else if (status === 'Unsigned') {
                return 'danger';
            } else if (status === 'pending') {
                return 'warning';
            } else {
                return 'warning';
            }
        },

        goToAdd () {
            this.$router.push({ name: 'Add Labourer Schedule' });
        },

        goToEdit (id) {
            this.$router.push({ name: 'Edit Labourer Schedule', params: { id } });
        },
        goToView (id) {
            this.$router.push({ name: 'View Labourer Schedule', params: { id } });
        },

        customSort () {
            return false;
        }
        ,

    },
}
;
</script>
